import React, { useEffect, useState } from "react";
import {
    Card,
    CardContent,
    Typography,
    Grid,
    FormControl,
    Autocomplete,
    TextField
} from "@mui/material";
import { Tree } from "react-organizational-chart";
import { TreeNode } from "react-organizational-chart";

const OrganigramaArbol = ({ organigrama }) => {
    const [root, setRoot] = useState(null);
    const [selectedUnidadSuperior, setSelectedUnidadSuperior] = useState(null);

    useEffect(() => {
        if (organigrama?.length > 0 && typeof window !== "undefined") {
            const rootCandidate = organigrama.find(
                (node) => node.new_name === selectedUnidadSuperior
            );

            setRoot(rootCandidate);
        }
    }, [organigrama, selectedUnidadSuperior]);

    const handleChangeUnidadSuperior = (event, value) => {
        setSelectedUnidadSuperior(value ? value.new_name : null);
    };

    const hasDescendants = (node) => {
        return organigrama.some(
            (item) => item._new_unidadsuperior_value === node.id
        );
    };

    const renderNode = (node) => (
        <TreeNode
            key={node.id}
            style={{ justifyContent: "center" }}
            label={
                <div style={{ textAlign: "center" }}>
                    <Grid container direction="column" alignItems="center">
                        <Card
                            sx={{
                                maxWidth: "200px",
                                margin: "8px",
                                textAlign: "center",
                            }}
                        >
                            <CardContent>
                                <Typography variant="subtitle1" sx={{ mt: 1 }}>
                                    {node.new_name}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {node.new_tipo}
                                </Typography>
                            </CardContent>
                        </Card>
                        {hasDescendants(node) && (
                            <div
                                style={{
                                    width: "2px",
                                    height: "20px",
                                    background: "#ccc",
                                }}
                            />
                        )}
                    </Grid>
                </div>
            }
        >
            {organigrama
                .filter(
                    (item) =>
                        item._new_unidadsuperior_value === node.id
                )
                .map(renderNode)}
        </TreeNode>
    );

    return (
        <Grid
            container
            sx={{ mt: 2 }}
            justifyContent="center"
            alignItems="center"
        >
            <Grid item xs={12}>
                <FormControl fullWidth sx={{ marginBottom: 2, padding: 4 }}>
                    <Autocomplete
                        value={organigrama.find(
                            (option) => option.new_name === selectedUnidadSuperior
                        )}
                        onChange={handleChangeUnidadSuperior}
                        options={organigrama}
                        getOptionLabel={(option) => option.new_name}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Seleccione una unidad organizativa"
                            />
                        )}
                    />
                </FormControl>
                <Tree
                    lineColor="#ccc"
                    lineWidth="2px"
                    style={{
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    {root ? renderNode(root) : null}
                </Tree>
            </Grid>
        </Grid>
    );
};

export default OrganigramaArbol;